import { render, staticRenderFns } from "./VueButton.vue?vue&type=template&id=06381c41&scoped=true&"
import script from "./VueButton.vue?vue&type=script&lang=js&"
export * from "./VueButton.vue?vue&type=script&lang=js&"
import style0 from "./VueButton.vue?vue&type=style&index=0&id=06381c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06381c41",
  null
  
)

export default component.exports